<template>
    <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6 p-0 footer-left">
              <p class="mb-0">Copyright © {{ anioActual }} SuperKompras</p>
            </div>
            <div class="col-md-6 p-0 footer-right">
              <p class="mb-0">
                Desarrollado por
                <a href="https://cideapps.com/" target="_blank" rel="noopener noreferrer" class="footer-link">CIDEAPPS</a>
              </p>
            </div>
          </div>
        </div>
      </footer>
</template>

<script>
export default {
  name: "FooterView",
  data() {
    return {
      anioActual: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.footer-link {
  font-weight: 600;
  color: var(--theme-deafult, #5c61f2);
  text-decoration: none;
}
.footer-link:hover {
  text-decoration: underline;
}
</style>
